import {
  defineStyle,
  createMultiStyleConfigHelpers,
  keyframes,
} from '@chakra-ui/react'
import { mode } from '@chakra-ui/theme-tools'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(['container', 'spinner', 'icon'])

const spin = keyframes({
  '0%': {
    transform: 'rotate(0deg)',
  },
  '100%': {
    transform: 'rotate(360deg)',
  },
})

const fadeIn = keyframes({
  '0%': {
    opacity: 0,
  },
  '100%': {
    opacity: 1,
  },
})

const baseStyle = definePartsStyle(props => {
  const { delay } = props

  return {
    container: {
      opacity: 0,
      animation: `${fadeIn} 600ms ease ${delay} 1 normal forwards`,
      borderRadius: 'full',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    spinner: {
      animation: `${spin} 0.5s ease-in-out infinite`,
      color: 'brand.500',
      borderBottomColor: mode('neutral.300', 'whiteAlpha.300')(props),
      borderLeftColor: mode('neutral.300', 'whiteAlpha.300')(props),
      borderRightColor: mode('neutral.300', 'whiteAlpha.300')(props),
    },
    icon: {
      color: 'white',
    },
  }
})

const variantDefault = definePartsStyle({
  container: {
    backgroundColor: 'transparent',
  },
})

const variantBotHead = definePartsStyle({
  container: {
    backgroundColor: 'blackAlpha.900',
  },
})

const variants = {
  default: variantDefault,
  'bot-head': variantBotHead,
}

const size = {
  sm: defineStyle({
    width: '6',
    height: '6',
  }),
  md: defineStyle({
    width: '8',
    height: '8',
  }),
  lg: defineStyle({
    width: '12',
    height: '12',
  }),
}

const sizes = {
  sm: definePartsStyle({
    container: size.sm,
    spinner: size.sm,
    icon: {
      width: '12px',
      height: '12px',
    },
  }),
  md: definePartsStyle({
    container: size.md,
    spinner: size.md,
    icon: {
      width: '16px',
      height: '16px',
    },
  }),
  lg: definePartsStyle({
    container: size.lg,
    spinner: size.lg,
    icon: {
      width: '21px',
      height: '21px',
    },
  }),
}

export const LoadingSpinner = defineMultiStyleConfig({
  baseStyle,
  sizes,
  variants,
  defaultProps: {
    variant: 'default',
    size: 'md',
  },
})
